import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwitchButtonComponent } from './switch-button.component';
import { FormsModule } from '@angular/forms';
import { TranslationModule } from 'src/app/i18n/translation.module';

@NgModule({
  declarations: [
    SwitchButtonComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslationModule
  ],
  exports: [SwitchButtonComponent]
})
export class SwitchButtonModule { }
